import { render, staticRenderFns } from "./DownloadXlsxBtn.vue?vue&type=template&id=757ec0c4"
import script from "./DownloadXlsxBtn.vue?vue&type=script&lang=js"
export * from "./DownloadXlsxBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports